module.exports = __webpack_public_path__ + "ee1ca9bca22d874c10cf60fea556d924.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/tomhorn/assets/167.png
// module id = 1760
// module chunks = 2